<template>
  <div class="con">
    <div class="con-inner">
      <h2 class="con-head">用户协议</h2>
      <div>
        <div
          v-for="(item, index) in textLines"
          :key="index"
          :class="{ paragraph: item.paragraph, title: item.title }"
        >
          {{ textFilter(item.text) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "中国机械总院集团武汉材料保护研究所有限公司公共服务平台",
      subName: "公共服务平台",
      textLines: [
        {
          paragraph: true,
          text: `尊敬的{name}注册用户（以下简称“用户”），感谢您使用我们的产品和服务（以下简称“服务”）。
        《{name}用户协议》（以下简称“本协议”）适用于{name}（以下简称"{subName}"）与用户之间关于使用{subName}相关服务所订立的协议，
        本协议内容包括协议正文及所有已经在{subName}发布和将来可能发布的各类规则和声明，所有规则和声明为本协议不可分割的一部分，
        与协议正文具有同等法律效力。`,
        },
        {
          paragraph: true,
          text: `为了更好的使用{subName}的各项服务，用户应当阅读并遵守本协议。
          请用户务必审慎阅读、充分理解各条款内容。用户使用{subName}的服务即视为用户已阅读并同意本协议的约束。协议具体如下：`,
        },
        {
          title: true,
          text: "一、{subName}账户",
        },
        {
          paragraph: true,
          text: `1.1申请者必须完全同意所有服务条款并完成注册程序，才能成为{subName}的正式用户，使用{subName}的全部服务。`,
        },
        {
          paragraph: true,
          text: `1.2用户应自行诚信的向{subName}提供注册资料，用户承诺其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。`,
        },
        {
          paragraph: true,
          text: `1.3 当实际情况发生变化时，用户要及时更新注册资料，符合及时、详尽、准确、真实的要求。
          果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，
          并且{subName}保留终止用户使用{subName}各项服务的权利。`,
        },
        {
          title: true,
          text: "二、隐私与版权保护",
        },
        {
          paragraph: true,
          text: `2.1 {subName}会根据中华人民共和国《知识产权法》以及《信息网络传播权保护条例》的规定，
          对权利人提出的涉嫌侵犯版权的通知书作出回应，包括终止对侵权内容的展示并终止屡次侵权人的帐户。`,
        },
        {
          paragraph: true,
          text: `2.2 根据中华人民共和国《信息网络传播权保护条例》的规定，如无正当理由拒绝，我们有责任应版权持有人的要求，
          向版权持有人提供涉嫌侵权的服务对象的个人数据如姓名（名称）、联系方式、网络地址等信息。`,
        },
        {
          title: true,
          text: "三、检测服务产品信息",
        },
        {
          paragraph: true,
          text: `{subName}上的检测服务产品价格、数量、检测参数等信息随时都有可能发生变动，{subName}不作特别通知。由于{subName}上服务产品信息的数量极其庞大，
          虽然{subName}会尽最大努力保证用户所浏览服务信息的准确性，
          但由于众所周知的互联网技术因素等客观原因存在，{subName}网页显示的信息可能会有一定的滞后性或差错，对此情形请用户知悉并理解；{subName}欢迎纠错，并会尽快改正。`,
        },
        {
          title: true,
          text: "四、订单",
        },
        {
          paragraph: true,
          text: `4.1 用户在下订单填写委托单时，请仔细确认所填写检测服务产品的名称、数量、样品型号和规格、检测技术要求、检测周期、检测后样品处理方式、联系电话等信息。`,
        },
        {
          paragraph: true,
          text: `4.2 部分检测项目在检测过程中会对样品进行损坏，请用户在下订单时仔细确认该检测项目是否是有损检测，因用户个人疏忽造成的损失，{subName}不承担任何责任。`,
        },
        {
          paragraph: true,
          text: `4.3 用户寄样过程中产生的快递费用需用户自行承担，{subName}不予承担样品寄送费用。`,
        },
        {
          title: true,
          text: `五、用户权利和义务`,
        },
        {
          paragraph: true,
          text: `5.1 用户有权利拥有{subName}的用户名及密码，并有权利使用其用户名及密码随时登录{subName}进行交易。用户不得以任何形式擅自转让或授权他人使用其{subName}用户名。`,
        },
        {
          paragraph: true,
          text: `5.2 用户有权根据本协议的规定以及{subName}上发布的相关规则，利用{subName}查询或使用{subName}上所提供的任何服务（如发布检测信息需求等），
          并可参加{subName}发布的有关活动以及有权享受{subName}提供的其它的有关信息服务及活动。`,
        },
        {
          paragraph: true,
          text: `5.3 用户可免费浏览{subName}上面的资讯，查询{subName}入驻的实验室信息，在线向实验室留言、询价、浏览展会专栏等；用户可参加{subName}不定期组织的线上、线下活动等。`,
        },
        {
          paragraph: true,
          text: `5.4 用户可在{subName}上免费发布检测信息；实验室用户可以进行竞标。`,
        },
        {
          paragraph: true,
          text: `5.5 用户在{subName}进行交易过程中如与其他用户因交易产生纠纷，可以请{subName}从中予以协调，
          用户如发现其他用户有违法或违反本协议的行为，可以向{subName}进行反映并要求处理。
          如用户因网上交易与其他用户产生诉讼的，用户有权通过司法部门要求{subName}提供相关资料。`,
        },
        {
          paragraph: true,
          text: `5.6 用户有义务在注册时提供其真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码和所发布内容的有效性、安全性、真实性，保证{subName}及所有用户可以通过上述联系方式与其进行联系。
          同时，用户也有义务在相关资料实际变更时及时更新有关注册资料并保证不以他人或其他组织的资料在{subName}进行注册或认证。`,
        },
        {
          paragraph: true,
          text: `5.7 用户应当保证在使用{subName}进行交易过程中遵守诚实信用的原则，不在交易过程中采取任何不正当行为。`,
        },
        {
          paragraph: true,
          text: `5.8 用户在{subName}上不得发布各类违法或违规信息；用户在{subName}上不得提供或买卖国家禁止销售或限制销售的服务，
          不得买卖侵犯他人知识产权或其它合法权益的服务，也不得买卖违背社会公共利益或公共道德的、或是{subName}认为不适合在{subName}上所提供的服务。`,
        },
        {
          paragraph: true,
          text: `5.9 用户承诺其在使用{subName}时实施的所有行为均遵守国家相关的法律、法规和{subName}的相关规定及协议和声明，
          以及各种社会公共利益或公共道德。如有违反导致任何法律后果的发生，用户将以其名义独立承担所有相应的法律责任。`,
        },
        {
          paragraph: true,
          text: `5.10 用户承诺，不对{subName}上任何数据作商业性利用或恶意更改，
          包括但不限于在未经{subName}事先书面批准的情况下，以复制、传播等方式使用在平台上展示的任何资料和数据。`,
        },
        {
          paragraph: true,
          text: `5.11 由于市场变化及各种以合理商业努力难以控制的因素的影响，{subName}无法完全保证您提交的订单信息中希望购买的检测服务都可以实施；
          如用户拟购买的服务无法按用户的要求实施时，用户有权取消订单。`,
        },
        {
          title: true,
          text: `六、{subName}权利和义务`,
        },
        {
          paragraph: true,
          text: `6.1 {subName}有义务在现有技术上维护整个平台服务的正常运行，并努力提升和改进技术，使用户在{subName}上的所有活动和服务得以顺利进行。`,
        },
        {
          paragraph: true,
          text: `6.2 对用户在使用{subName}中所遇到的问题及反映的情况，会及时作出回复。`,
        },
        {
          paragraph: true,
          text: `6.3 对于用户在{subName}上的任何不当行为或其它任何{subName}认为应当终止其服务的情况，{subName}有权随时做出删除其相关信息、终止其服务提供等处理，
          无须征得用户的同意；{subName}有权根据不同情况选择是否保留或删除其相关信息及是否继续或停止对该用户提供服务，并追究其相关法律责任。`,
        },
        {
          paragraph: true,
          text: `6.4 因互联网交易的特殊性，{subName}没有义务对所有用户提供的服务以及与交易有关的其它服务和事项进行事先任何全部审查。`,
        },
        {
          paragraph: true,
          text: `6.5 用户在{subName}交易过程中如与其它用户因交易产生纠纷，可请求{subName}从中予以协调。如因此而产生诉讼的，用户可通过司法部门或行政部门依照法定程序要求{subName}提供相关数据，
          {subName}会配合提供有关资料，但不承担由此而产生的一切相关责任；{subName}有权对用户发布的全部内容及交易行为进行查阅，
          发现其发布内容或交易行为中存在任何问题或怀疑，均有权向用户发出询问及要求改正的通知或者直接做出删除等处理。`,
        },
        {
          paragraph: true,
          text: `6.6 许可使用权：用户以此授予{subName}独家的、通用的、永久的、许可使用权利 (并有权对该权利进行再授权)，
          使{subName}有权(全部或部分地)使用、复制、修订、改写、发布、翻译、分发、执行和展示用户公示于网站的各类信息、数据或制作其派生作品，
          和或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内`,
        },
        {
          title: true,
          text: `七、服务的中断或终止`,
        },
        {
          paragraph: true,
          text: `7.1 在用户违反本协议相关规定时，{subName}有权中断或终止向该用户提供服务，{subName}将在中断或终止服务时通知用户。
          但如该用户在被{subName}中断或终止提供服务后，再一次直接或间接或以他人名义注册为{subName}用户的，{subName}有权再次单方面终止向该用户提供服务。`,
        },
        {
          paragraph: true,
          text: `7.2 如{subName}通过用户提供的信息与用户联系时，发现用户在注册时填写的注册信息已不存在或无法找到其电子邮箱地址的，
          经平台以其它联系方式通知用户更改后而用户仍未能尽快提供新的电子邮箱地址及注册信息的，{subName}有权终止向该用户提供服务。`,
        },
        {
          paragraph: true,
          text: `7.3 其它{subName}认为需中断或终止服务的情况。`,
        },
        {
          title: true,
          text: `八、免责声明`,
        },
        {
          paragraph: true,
          text: `8.1 除本条款或附加条款中明确规定的内容外，{subName}及其入驻实验室对服务均不作任何具体承诺。
          例如，我们对服务内容、服务的具体功能，或其可靠性、可用性或满足您需要的能力不作任何承诺。`,
        },
        {
          paragraph: true,
          text: `8.2 对于用户提交给{subName}的信息，{subName}一般会进行审核。但{subName}不保证进行审核，且{subName}不保证审核的有效性。
          如果您提交的信息涉嫌侵权，{subName}将不承担连带责任。`,
        },
        {
          paragraph: true,
          text: `8.3 {subName}新闻资讯、检测服务项目等板块部分收集的公开资料信息来源于互联网，目的在于网络分享，{subName}不对其真实性负责。
          如果您发现{subName}上有侵犯您的知识产权的信息，请与{subName}取得联系，{subName}会及时修改或删除。`,
        },
        {
          paragraph: true,
          text: `8.4 {subName}新闻资讯、检测服务项目等板块部分信息，只供参考之用。本网站不保证信息的准确性、有效性、及时性和完整性。
          {subName}及其雇员一概毋须以任何方式就任何信息传递或传送的失误、不准确或错误，对用户或任何其他人士负任何直接或间接责任。
          在法律允许的范围内，{subName}在此声明，不承担用户或任何人士就使用或未能使用本网站所提供的信息或任何链接所引致的任何直接、间接、附带、从属、特殊、惩罚性或惩戒性的损害赔偿。`,
        },
        {
          title: true,
          text: `九、赔偿`,
        },
        {
          paragraph: true,
          text: `用户明确理解并同意，如因其违反有关法律法规或者本协议之规定，使{subName}因此遭受损失并受到任何第三方的索赔，
          或任何行政管理部门的处罚，用户应对{subName}提供赔偿（律师费用等）。`,
        },
        {
          title: true,
          text: `十、管辖`,
        },
        {
          paragraph: true,
          text: `{subName}用户协议均应依照中华人民共和国相关法律予以遵守及处理。`,
        },
        {
          title: true,
          text: `十一、最终解释权`,
        },
        {
          paragraph: true,
          text: `本协议和免责声明的最终解释权归{subName}所有。`,
        },
      ],
    };
  },
  methods: {
    textFilter(val) {
      return val
        .replaceAll("{name}", this.name)
        .replaceAll("{subName}", this.subName);
    },
  },
};
</script>
<style scoped lang="scss">
@import "./common.scss";
</style>
